import { createContext, type FC, type PropsWithChildren, useContext } from 'react';

import type { Attachment } from '../lib/types';

interface AttachmentsContextValue {
  fileKeys: string[];
  attachmentsRecord: Map<string, Attachment>;
  setFileToUpload: (file: File) => void;
  removeAttachment: (fileKey: string, isUploaded: boolean, isDefault: boolean) => void;
}

interface AttachmentsContextProviderProps extends PropsWithChildren {
  value: AttachmentsContextValue;
}

const AttachmentsContext = createContext<AttachmentsContextValue | null>(null);

export const AttachmentsContextProvider: FC<AttachmentsContextProviderProps> = ({
  children,
  value,
}) => {
  return <AttachmentsContext.Provider value={value}>{children}</AttachmentsContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAttachmentsContext = () => {
  const context = useContext(AttachmentsContext);

  if (!context) {
    throw new Error('useAttachmentsContext must be used within a AttachmentsContextProvider');
  }

  return context;
};
